import React, { Component } from 'react';
import { Field, ErrorMessage } from 'formik';
import { iconForField } from '../../common/custom/icon-library';
import FormFieldWithLabel from '../common/FormFieldWithLabel';
import TooltipInfo from '../../common/docs/TooltipInfo';

class ConsoleLogOptions extends Component {
  render() {
    const { values } = this.props;

    return (
      <div style={{ marginLeft: '30px' }}>
        <div className="form-group">
          <div className="input-group">
            <div className="input-group-prepend" title="Enable Console Logs">
              <span className="input-group-text">
                <i className={`wb ${iconForField('boolean-toggle')}`}></i>
              </span>
            </div>
            <div className="form-check">
              <label className="form-check-label">
                <Field
                  type="checkbox"
                  name="enableConsoleLog"
                  className="form-check-input"
                  title="Enable Console Logs"
                />
                Enable Console Logs
                <span className="form-check-sign">
                  <span className="check"></span>
                </span>
              </label>
            </div>
            <TooltipInfo
              title={`Enable it to console log in your web browser.`}
              headerText={`What's this ?`}
              showHeader={true}
              showArrow={true}
              append={true}
            />
          </div>
          <ErrorMessage name="enableConsoleLog" component="p" className="text-error ml-5" />
        </div>
        {values['enableConsoleLog'] && (
          <div style={{ marginLeft: '30px' }}>
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label="Entry Log Message"
                icon="text"
                infoIcon={true}
                infoDescription={`Enter the log message which you want to display as soon as action is triggered in your web browser.`}
              >
                <Field
                  type="text"
                  name="startConsoleLog"
                  className="form-control form-control-sm"
                  autoComplete="off"
                  placeholder="Log message on entry"
                />
              </FormFieldWithLabel>
              <ErrorMessage name="startConsoleLog" component="p" className="text-error ml-5" />
            </div>
            <div className="form-group">
              <FormFieldWithLabel
                cta={false}
                label="Exit Log Message"
                icon="text"
                infoIcon={true}
                infoDescription={`Enter the log message which you want to display just before action leaves in your web browser.`}
              >
                <Field
                  type="text"
                  name="endConsoleLog"
                  className="form-control form-control-sm"
                  autoComplete="off"
                  placeholder="Log message on exit"
                />
              </FormFieldWithLabel>
              <ErrorMessage name="endConsoleLog" component="p" className="text-error ml-5" />
            </div>
            {/* <div className="form-group">
              <div className="input-group">
                <div className="input-group-prepend" title="Enable Console Log Arguments">
                  <span className="input-group-text">
                    <i className={`wb ${iconForField('boolean-toggle')}`}></i>
                  </span>
                </div>
                <div className="form-check">
                  <label className="form-check-label">
                    <Field
                      type="checkbox"
                      name="enableConsoleLogArgs"
                      className="form-check-input"
                      title="Enable Console Log Arguments"
                    />
                    Enable Console Logs Arguments
                    <span className="form-check-sign">
                      <span className="check"></span>
                    </span>
                  </label>
                </div>
                <TooltipInfo
                  title={`Enable it to pass arguments in console log in your web browser.`}
                  headerText={`What's this ?`}
                  showHeader={true}
                  showArrow={true}
                  append={true}
                />
              </div>
              <ErrorMessage name="enableConsoleLogArgs" component="p" className="text-error ml-5" />
            </div>
            {values['enableConsoleLogArgs'] && (
              <div style={{ marginLeft: '30px' }}>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Entry Log Arguments (Optional)"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter the entry console log argument(s) comma [,] separated that exists in an action which you want to display as soon as action is triggered in your web browser.`}
                  >
                    <Field
                      type="text"
                      name="startConsoleLogArgs"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="(Optional) Entry console log argument list (comma [,] separated)"
                    />
                  </FormFieldWithLabel>
                  <ErrorMessage
                    name="startConsoleLogArgs"
                    component="p"
                    className="text-error ml-5"
                  />
                </div>
                <div className="form-group">
                  <FormFieldWithLabel
                    cta={false}
                    label="Exit Log Arguments (Optional)"
                    icon="text"
                    infoIcon={true}
                    infoDescription={`Enter the exit console log argument(s) comma [,] separated that exists in an action which you want to display as soon as action is about to leave in your web browser.`}
                  >
                    <Field
                      type="text"
                      name="endConsoleLogArgs"
                      className="form-control form-control-sm"
                      autoComplete="off"
                      placeholder="(Optional) Exit console log argument list (comma [,] separated)"
                    />
                  </FormFieldWithLabel>
                  <ErrorMessage
                    name="endConsoleLogArgs"
                    component="p"
                    className="text-error ml-5"
                  />
                </div>
              </div>
            )} */}
          </div>
        )}
      </div>
    );
  }
}

export default ConsoleLogOptions;
